import React from "react";
import styled from "styled-components";

import CambioPerfil from "../CambioPerfil";

const Card=styled.div`

background:white;

border-radius:18px;

padding:28px;

box-shadow:0 8px 25px rgba(0,0,0,.08);

display:flex;

justify-content:space-between;

align-items:center;

flex-wrap:wrap;

gap:20px;

`;

const Title=styled.h2`

margin:0;

font-size:2rem;

`;

const Subtitle=styled.p`

margin-top:8px;

color:#666;

`;

export default function HeroProfesorCard({

usuario,

cantidadGrupos,

perfilActivo,

onCambiarPerfil

}){

return(

<Card>

<div>

<Title>

👨‍🏫 Hola {usuario?.nick || usuario?.nombre || "Profesor"}

</Title>

<Subtitle>

Actualmente administras <b>{cantidadGrupos}</b> grupo{cantidadGrupos!==1 && "s"}.

</Subtitle>

</div>

<div>

<CambioPerfil

perfilActivo={perfilActivo}

onCambiarPerfil={onCambiarPerfil}

/>

</div>

</Card>

);

}